module.exports = __webpack_public_path__ + "media/images/sp/specials/common/icon_plus-466d9eb634eb3f1c4ab8205042e6f587.svg";